import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { CreateContact, CreateContactGroup, contactAndContactGroupDetails } from '../models/contact-model';

import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { HttpEventType, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ContactsService {

  constructor(private http: HttpClient) { }

  createContact(payload: any) {
    return this.http.post<any>(environment.apiUrl + 'Contacts/AddContact/', payload);
  }
  createUser(payload: any) {
    return this.http.post<any>(environment.apiUrl + 'Users/AddUser/', payload);
  }


  getAllContacts(payload: any) {
    return this.http.post<any>(environment.apiUrl + 'Contacts/FetchAllContacts/', payload);
  }

  deleteContacts(id: number) {
    return this.http.delete(environment.apiUrl + '' + id);
  }

  updateContact(payload: any) {
    return this.http.post<any>(environment.apiUrl + 'Contacts/UpdateContact/', payload);
  }

  getAllContactGroups() {
    return this.http.get<CreateContactGroup[]>(environment.apiUrl + 'Contacts/FetchAllGroups');
  }

  createContactGroup(payload: any) {
    return this.http.post<CreateContactGroup[]>(environment.apiUrl + 'Contacts/AddGroup/', payload);
  }

  updateContactGroup(payload: any) {
    return this.http.post<any>(environment.apiUrl + 'Contacts/UpdateGroup/', payload);
  }

  fetchAllAssignedContacts(payload: any) {
    return this.http.post<any>(environment.apiUrl + 'Contacts/FetchAllAssignedContactsToGroup/', payload);
  }

  assignContactsToGroup(payload: any) {
    return this.http.post<any>(environment.apiUrl + 'Contacts/AddContactsToGroup/', payload);
  }

  assignGroupsToContact(payload: any) {
    return this.http.post<any>(environment.apiUrl + 'Contacts/AddGroupsToContact/', payload);
  }

  fetchAllAssignedGroupsToContact(payload: any) {
    return this.http.post<any>(environment.apiUrl + 'Contacts/FetchAllAssignedGroupsToContact/', payload);
  }

  uploadContactsCSV(payload: any) {
    return this.http.post(environment.apiUrl + 'Contacts/Upload/', payload, { reportProgress: true, observe: 'events' })
  }

  uploadLeadsCSV(payload: any) {
    return this.http.post(environment.apiUrl + 'LeadsManagement/ImportLeadRequestsFromCSV/', payload, { reportProgress: true, observe: 'events' })
  }

  addSpecialitiesToContactGroup = (payload: any): Observable<any> => {
    return this.http.post(`${environment.apiUrl}Contacts/AddSpecialitesToContactGroup`, payload)
  }
  
  fetchAllAssingedGroupSpecialityContacts = (payload: any): Observable<any> => {
    return this.http.post(`${environment.apiUrl}Contacts/FetchAllAssingedGroupSpecialityContacts`, payload)
  }

  fetchAllAssingedSpecialitiesToGroup = (groupId : Number): Observable<any> => {
    return this.http.get(environment.apiUrl+"Contacts/FetchAllAssingedSpecialitiesGroup/"+groupId)
  }
}
